import { AttachmentApiModel } from '@app/api/api-models/attachments';
import { AActivityIcon } from '@app/api/api-models/activities/a-activity-icon';
import { ActivitySkillApiModel } from '@app/api/api-models/activities/ActivitySkillApiModel';
import { ActivityPerformanceCategoryApiModel } from '@app/api/api-models/activities/ActivityPerformanceCategoryApiModel';
import { CustomUtils } from '@app/shared/utils/custom-utils';
import { ActivityCallTypeApiModel } from '@app/api/api-models/activities/ActivityCallTypeApiModel';

export class ActivityApiModel extends AActivityIcon {
  public Id = 0;
  public FormInstanceId: number = null;
  public FormInstanceName = '';
  public FormInstanceNumber = '';
  public FormInstanceNameWithNumber = '';
  public CompletedOn: Date = null;
  public Comment = '';
  public Number = '';
  public CadNumber = '';
  public Trainer = '';
  public Skills = new Array<ActivitySkillApiModel>();
  public PerformanceCategories = new Array<ActivityPerformanceCategoryApiModel>();
  public CallTypes = new Array<ActivityCallTypeApiModel>();
  public Attachments = new Array<AttachmentApiModel>();
  public IsImported: boolean;
  public IsViewable: boolean;
  public IsManualComplete: boolean;

  public name?: string;

  public deserialize(data: Object): ActivityApiModel {
    Object.assign(this, data);

    this.CompletedOn = new Date(this.CompletedOn);

    this.name = this.Skills.map((x) => x.Name)
      .concat(this.PerformanceCategories.map((x) => x.Name))
      .concat(this.CallTypes.map((x) => x.Name))
      .join(', ');

    this.FormInstanceNameWithNumber = CustomUtils.concatFormNameWithNumber(
      this.FormInstanceName,
      this.FormInstanceNumber
    );

    return this;
  }
}
